import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";

function Policy() {
  return (
    <>
      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto px-4">
        <Breadcrumbs />
      </div>

      {/* Hero Section */}
      <div className="bg-gray-100 py-12 mb-10">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold text-blue-700 mb-2">Our Policies</h1>
          <p className="text-gray-600 text-sm">
            Learn how we protect your privacy, process orders, and handle deliveries with care and transparency.
          </p>
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-4xl mx-auto px-4 pb-12">
        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            1. Order and Fulfillment Timing
          </h2>
          <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
            <li>
              <span className="font-medium">24/7 Ordering:</span> Customers can place
              orders at any time, around the clock.
            </li>
            <li>
              <span className="font-medium">Daily Calculation:</span> Fulfillment is
              based on a daily calculation, prioritizing orders placed overnight. For
              example, orders placed at midnight will be fulfilled before those placed at
              8 AM when the business officially opens.
            </li>
            <li>
              <span className="font-medium">Business Hours:</span> Officially open for
              business and order fulfillment from 8 AM to 5 PM CST.
            </li>
            <li>
              <span className="font-medium">Delivery Timeframe:</span> Standard delivery
              occurs within 3 to 5 hours after the order is placed, but only during
              office hours (8 AM - 5 PM CST).
            </li>
            <li>
              <span className="font-medium">Orders After 3 PM CST:</span> Orders placed
              after 3 PM CST will be delivered the following day, unless the customer
              pays an "instant delivery fee."
            </li>
            <li>
              <span className="font-medium">Instant Delivery Fee:</span> A $50 fee
              guarantees same-day delivery for orders placed after 3 PM CST.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            2. Delivery Charges
          </h2>
          <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
            <li>
              <span className="font-medium">Free Delivery:</span> All orders qualify for
              free delivery, except when the <span className="italic">"instant delivery fee"</span> 
              is applied for orders placed after 3 PM CST.
            </li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            3. Privacy Policy
          </h2>
          <ul className="list-disc pl-5 text-gray-700 text-sm leading-relaxed space-y-2">
            <li>
              We value your privacy. Customer information is collected solely for the purpose of order
              fulfillment and communication. We do not share or sell your data to third parties.
            </li>
          </ul>
        </section>

        {/* Back to Home Link */}
        <div className="text-center">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:underline text-sm font-medium"
          >
            ← Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default Policy;
